var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-container"},[_c('index-header'),_c('div',{staticClass:"index-content"},[_c('div',{staticClass:"scrollbar"},[_c('router-view'),_c('index-footer')],1)]),[_c('el-backtop',{attrs:{"visibility-height":100,"bottom":60}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }